<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,11C9,11.55,9.45,12,10,12C10.28,12,10.53,11.89,10.71,11.71C10.71,11.71,14.71,7.71,14.71,7.71C14.89,7.53,15,7.28,15,7C15,6.45,14.55,6,14,6C13.72,6,13.47,6.11,13.29,6.29C13.29,6.29,9.29,10.29,9.29,10.29C9.11,10.47,9,10.72,9,11C9,11,9,11,9,11ZM4,6C4.28,6,4.53,5.89,4.71,5.71C4.71,5.71,8.71,1.71,8.71,1.71C8.89,1.53,9,1.28,9,1C9,0.45,8.55,0,8,0C7.72,0,7.47,0.11,7.29,0.29C7.29,0.29,3.29,4.29,3.29,4.29C3.11,4.47,3,4.72,3,5C3,5.55,3.45,6,4,6C4,6,4,6,4,6ZM8,10C8,10,13,5,13,5C13,5,12.21,4.21,12.21,4.21C12.21,4.21,12.71,3.71,12.71,3.71C12.89,3.53,13,3.28,13,3C13,2.45,12.55,2,12,2C11.72,2,11.47,2.11,11.29,2.29C11.29,2.29,10.79,2.79,10.79,2.79C10.79,2.79,10,2,10,2C10,2,5,7,5,7C5,7,5.79,7.79,5.79,7.79C5.79,7.79,0.29,13.29,0.29,13.29C0.11,13.47,0,13.72,0,14C0,14.55,0.45,15,1,15C1.28,15,1.53,14.89,1.71,14.71C1.71,14.71,7.21,9.21,7.21,9.21C7.21,9.21,8,10,8,10C8,10,8,10,8,10ZM15,14C15,14,7,14,7,14C6.45,14,6,14.45,6,15C6,15.55,6.45,16,7,16C7,16,15,16,15,16C15.55,16,16,15.55,16,15C16,14.45,15.55,14,15,14C15,14,15,14,15,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TakeAction',
} as DefineComponent
</script>
